<template>
    <div>
      <div class="ext-toast-all-box">
        <div class="ext-toast-box">
          <div class="ext-toast-main">
            <p style="display:none;">
              <img src="@/assets/toast.png"/>
            </p>
            <h3>{{toast_text}}</h3>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'Toast',
  props: ['toast_text']
}
</script>
<style scoped>
.ext-toast-all-box { width:100%; height:100%; position: fixed; top:0px; left:0px; background: rgba(0,0,0,0.5); z-index: 9999999;}
.ext-toast-box { width:300px; height:100px; position: fixed; top:250px; left:50%;flex-wrap:wrap;-moz-box-shadow:0px 2px 11px rgba(0,0,0,0.08); -webkit-box-shadow:0px 2px 11px rgba(0,0,0,0.08); box-shadow:0px 2px 11px rgba(0,0,0,0.08); align-content:flex-start; margin-left:-150px; z-index: 9999999; background: #ffffff; border:1px solid #cccccc; border-radius: 10px;}
  .ext-toast-main { width:300px; height:100px;flex-wrap:wrap; align-content:flex-start;}
  .ext-toast-main p { width:100%; height:60px; margin:20px 0px 0px 0px;}
  .ext-toast-main p img { width:60px; height:60px; margin:0px 120px;}
  .ext-toast-main h2 { width:100%; height:50px;  line-height:50px; font-size:24px; margin:0px; text-align: center; justify-content: center;}
  .ext-toast-main h3 { width:100%; height:auto;  line-height:20px; font-size:16px; margin:35px 0px 0px 0px; padding:0px 30px;text-align: center; justify-content: center;}
</style>



// WEBPACK FOOTER //
// src/components/toast/index.vue